export const EMBED_SOURCE = 'pudelek-embed';
export const PARENT_SOURCE = 'pudelek-embed-parent';

export const postToParent = (type, data = {}) => {
	if (window.parent === window) return;
	window.parent.postMessage({ source: EMBED_SOURCE, type, ...data }, '*');
};
